<!-- No connection screen -->

<div
  id="AppContent"
  [ngClass]="
    outsideAppContext && !isFullScreenMessage ? 'body-general' : 'body-login'
  "
  [class]="this.businessUnit.theme"
>
  <!-- Header -->
  <header
    class="header grey flex-row justify-between items-center"
    [ngClass]="{
      'impersonation-background': isImpersonated,
    }"
  >
    <div
      class="flex-row justify-between items-center basis-100"
      [ngClass]="{
        'd-flex': !(isFullScreenMessage || isLogoScreen),
      }"
      [hidden]="isFullScreenMessage || isLogoScreen"
    >
      <div class="basis-35 d-flex items-center">
        <button
          [ngClass]="{
            hidden: this.currentRoute === '/login',
            none: this.currentRoute === '/login' && this.isMobile,
          }"
          mat-icon-button
          class="hamburger-menu"
          (click)="snav.toggle()"
        >
          <em class="fas fa-bars"></em>
        </button>
        <span
          class="logo-image"
          [ngClass]="{
            inline: this.currentRoute === '/login',
          }"
        ></span>
      </div>
      <div class="basis-30 xs-basis-40 d-flex justify-center">
        <span class="primary-color current-module">
          {{ this.currentModule?.translateKey | translate }}
        </span>
      </div>
      <div
        class="language-container d-flex justify-end basis-35 xs-basis-20"
        *ngIf="outsideAppContext"
      >
        <button
          id="lang-nl"
          (click)="setLanguage('nl')"
          class="menu-elements reset-button font-14"
          [ngClass]="{
            'is-active': isNl && !isImpersonated,
            'button-is-inactive': !isNl,
            'impersonation-language': isImpersonated && isNl,
          }"
        >
          NL
        </button>
        <span class="menu-elements font-14">|</span>
        <button
          id="lang-en"
          (click)="setLanguage('en')"
          class="menu-elements reset-button font-14"
          [ngClass]="{
            'is-active': isEng && !isImpersonated,
            'button-is-inactive': !isEng,
            'impersonation-language': isImpersonated && isEng,
          }"
        >
          EN
        </button>
        <button id="help" class="reset-button">
          <div class="img-container">
            <em class="logout-img fa fa-question-circle" (click)="help()"></em>
          </div>
        </button>
      </div>
    </div>
  </header>

  <!-- TODO: EXTRACT IN A NEW COMPONENT -->
  <div class="full-screen-message" [hidden]="!isFullScreenMessage">
    <div class="full-screen-message-container fsm-img-container">
      <img class="logo reload-logo" [src]="logoPath" alt="logo" />
    </div>

    <div class="full-screen-message-container fsm-txt-container">
      <div *ngIf="!noConnectionModalHidden; else timeout">
        <h3 class="description-text text-center">
          {{ 'SHARED.NO-CONNECTION-TITLE' | translate }}
        </h3>
        <h3 class="description-text text-center">
          {{ 'SHARED.NO-CONNECTION-SUBTITLE' | translate }}
        </h3>
      </div>
      <ng-template #timeout>
        <div>
          <h3 class="description-text text-center">
            {{ 'SHARED.TIMEOUT-TITLE' | translate }}
          </h3>
          <h3 class="description-text text-center">
            {{ 'SHARED.TIMEOUT-SUBTITLE' | translate }}
          </h3>
        </div>
      </ng-template>
    </div>

    <div class="full-screen-message-container fsm-btn-container">
      <div>
        <button
          type="button"
          id="btnReloadPage"
          (click)="reload()"
          class="btn btn-primary loading-button"
        >
          <span class="loading-button-txt text-center">{{
            'SHARED.RELOAD-PAGE-BUTTON-TEXT' | translate
          }}</span>
        </button>
      </div>
    </div>
  </div>

  <mat-sidenav-container
    [hidden]="isFullScreenMessage"
    [class.sidenav-open]="sideNav.opened"
    [class.sidenav-content-container-scrollable]="scrollable"
    class="example-sidenav-container basis-100"
  >
    <mat-sidenav class="sidenav" #snav [mode]="'over'" fixedTopGap="56">
      <div class="sidenav-container flex-1 d-flex flex-column">
        <div class="menu-item-container">
          <span
            class="float-left profile-container"
            *ngIf="insideAppContext && !isFullScreenMessage"
          >
            <button class="profile-button float-left mx-4">
              <em class="menu-elements fas fa-user user-badge"></em>
              <span class="menu-elements user-setting">
                {{ getUserInfo?.preferred_username }}
              </span>
            </button>
          </span>
        </div>
        <mat-nav-list>
          <a
            *ngIf="canSeeMyProfile"
            mat-list-item
            disableRipple
            [ngClass]="'raised'"
            class="side-menu-item"
            (click)="myProfile(); snav.close()"
          >
            <span
              class="badge incidents-badge warn-badge carrier-profile-badge"
              matBadge="&#8288;"
              matBadgeSize="small"
              [matBadgeHidden]="!showUploadCertificatesBadge"
              matBadgeColor="warn"
            >
              <em
                class="fas fa-user-circle ml-4 side-menu-home-icon"
                id="my-profile"
              ></em>
            </span>
            <span
              class="mx-4"
              [ngClass]="{
                'current-route': this.currentRoute.includes(
                  carrierProfileModule.path
                ),
                'nav-text': !this.currentRoute.includes(
                  carrierProfileModule.path
                ),
              }"
            >
              {{ carrierProfileModule.translateKey | translate }}
            </span>
          </a>
          <a
            mat-list-item
            [ngClass]="'raised'"
            class="side-menu-item"
            disableRipple
            (click)="routeTo(homeModule.path); snav.close()"
          >
            <span class="badge incidents-badge">
              <em class="fas fa-home ml-4 side-menu-home-icon"></em>
            </span>
            <span
              class="mx-4"
              [ngClass]="{
                'current-route': this.currentRoute.includes(homeModule.path),
                'nav-text': !this.currentRoute.includes(homeModule.path),
              }"
            >
              {{ homeModule.translateKey | translate }}
            </span>
          </a>
          <a
            *ngFor="
              let module of availableModulesForMenu
                ? availableModulesForMenu
                : []
            "
            mat-list-item
            disableRipple
            [ngClass]="!module.available ? 'is-inactive' : 'raised'"
            [disabled]="!module.available"
            class="side-menu-item"
            [style.display]="
              !module.available ||
              (module.name == Module.Tenders && (isMobile || isTablet))
                ? 'none'
                : 'block'
            "
            (click)="routeTo(module.path); snav.close()"
            [ngSwitch]="module.name"
          >
            <span
              *ngSwitchCase="Module.FreightExchange.toString()"
              [matBadge]="this.freightExchangeOrders"
              class="badge incidents-badge"
              [matBadgeHidden]="!showFreightExchangeBadge(module)"
              ><img
                src="{{ module.iconPath }}"
                class="side-menu-icon ml-4"
                alt="{{ module.name }}"
            /></span>
            <span
              *ngSwitchCase="Module.Incidents.toString()"
              [matBadge]="this.openIncidents"
              class="badge incidents-badge"
              [matBadgeHidden]="!showIncidentsBadge(module)"
              ><img
                src="{{ module.iconPath }}"
                class="side-menu-icon ml-4"
                alt="{{ module.name }}"
            /></span>
            <span *ngSwitchDefault class="badge"
              ><img
                src="{{ module.iconPath }}"
                class="side-menu-icon ml-4"
                alt="{{ module.name }}"
            /></span>

            <span
              class="mx-4"
              [ngClass]="{
                'current-route': this.currentRoute.includes(module.path),
                'nav-text': !this.currentRoute.includes(module.path),
              }"
            >
              {{ module.translateKey | translate }}
            </span>
          </a>
          <a
            *ngIf="
              (insideAppContext && !isFullScreenMessage) ||
              canOutsideAppContextRoutesFromHelp
            "
            mat-list-item
            disableRipple
            [ngClass]="'raised'"
            class="side-menu-item"
            (click)="changePassword(); snav.close()"
          >
            <span class="badge incidents-badge">
              <em class="ml-4 fas fa-key side-menu-home-icon"></em>
            </span>
            <span
              class="mx-4"
              [ngClass]="{
                'current-route': this.currentRoute.includes(
                  changePasswordModule.path
                ),
                'nav-text': !this.currentRoute.includes(
                  changePasswordModule.path
                ),
              }"
            >
              {{ changePasswordModule.translateKey | translate }}
            </span>
          </a>
          <a
            *ngIf="canSeeHelp"
            mat-list-item
            disableRipple
            [ngClass]="'raised'"
            class="side-menu-item"
            (click)="help(); snav.close()"
          >
            <span class="badge incidents-badge">
              <em class="ml-4 fa fa-question-circle side-menu-home-icon"></em>
            </span>
            <span
              class="mx-4"
              [ngClass]="{
                'current-route': this.currentRoute.includes(helpModule.path),
                'nav-text': !this.currentRoute.includes(helpModule.path),
              }"
            >
              {{ helpModule.translateKey | translate }}
            </span>
          </a>
          <a
            *ngIf="
              (insideAppContext && !isFullScreenMessage) ||
              canOutsideAppContextRoutesFromHelp
            "
            mat-list-item
            disableRipple
            [ngClass]="'raised'"
            class="side-menu-item"
            (click)="logout(); snav.close()"
          >
            <span class="badge incidents-badge">
              <em class="ml-4 fa fa-sign-out-alt side-menu-home-icon"></em>
            </span>
            <span
              class="mx-4"
              [ngClass]="{
                'current-route': this.currentRoute.includes(logoutModule.path),
                'nav-text': !this.currentRoute.includes(logoutModule.path),
              }"
            >
              {{ logoutModule.translateKey | translate }}
            </span>
          </a>
        </mat-nav-list>
      </div>
    </mat-sidenav>

    <mat-sidenav-content
      class="h-full"
      [class.sidenav-content-scrollable]="scrollable"
    >
      <div [hidden]="isFullScreenMessage" class="sidenav-content-container">
        <app-breadcrumb
          *ngIf="showBreadcrumb"
          [homeRoute]="'/secure/dashboard'"
          [breadcrumbs]="breadcrumbs"
          (navigateBackEvent)="this.navigateBack()"
          (routeToEvent)="routeTo($event)"
          [isMobile]="isMobile"
        >
        </app-breadcrumb>

        <router-outlet>
          <app-loading-indicator
            *ngIf="nagivateInProgress"
            [loadingMessage]="loadingMessage"
          ></app-loading-indicator>
        </router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- Alternate css based on Businessunit -->
  <link
    rel="stylesheet"
    [href]="sanitizer.bypassSecurityTrustResourceUrl(this.businessUnit.css)"
    type="text/css"
  />
  <footer [class]="this.businessUnit.theme" id="app-footer">
    <div class="row">
      <div class="col-12">
        <div class="bottom-border">
          <p class="text-center onprimary">
            <span>
              {{ footerDetails }}
            </span>
            <span>v{{ currentVersion }}</span>
          </p>
        </div>
      </div>
    </div>
  </footer>
</div>
